<template>
  <div v-if="editionMode">
    <SelectComponent
      v-model="localModelValue"
      :values="orderedTasks"
      :label="$t('attributes.task')"
      :required="required"
      name=""
      searchable
    />
    <ErrorContainer error-key="task_id" :errors="errors" />
  </div>
  <BaseShowLabel
    v-else
    :label="$t('attributes.task')"
    :model-value="selectedLabel"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'
import ErrorContainer from '@c/addf-package/components/BaseShowEditInput/ErrorContainer.vue'

export default {
  name: 'SelectTasks',
  components: { ErrorContainer, BaseShowLabel, SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    ...mapGetters({
      tasks: 'metadata/getMetadataTasks'
    }),
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    selectedLabel() {
      return this.tasks.find((task) => task.id === this.modelValue)?.name
    },
    orderedTasks() {
      return this.tasks.sort((a, b) => a.name.localeCompare(b.name))
    }
  }
}
</script>
